// src/Dashboard/pages/admin/Attendance/Attendance.jsx
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScrollToTop";

import useAttendance from "./hooks/useAttendance";

import AttendanceHero from "./components/AttendanceHero";
import AttendanceStats from "./components/AttendanceStats";
import AttendanceGroupPicker from "./components/AttendanceGroupPicker";
import AttendanceToolbar from "./components/AttendanceToolbar";
import AttendanceAdherentsGrid from "./components/AttendanceAdherentsGrid";
import AttendanceEmptyState from "./components/AttendanceEmptyState";

import AttendanceModeTabs from "./components/AttendanceModeTabs";
import AttendanceTablePanel from "./components/AttendanceTablePanel";
import AttendanceChartsPanel from "./components/AttendanceChartsPanel";
import AttendanceDeletePanel from "./components/AttendanceDeletePanel";

export default function Attendance() {
  useScrollToTop();

  const {
    loading,
    groups,
    selectedGroup,
    activePanel,
    setActivePanel,

    filters,
    setFilter,

    adherents,
    groupAdherents,
    filteredAdherents,

    attendance,
    assiduityInfo,
    savingIds,

    stats,
    table,
    charts,
    deletePanel,

    actions,
  } = useAttendance();

  const hasSelectedGroup = Boolean(filters.selectedGroupId);

  return (
    <div className="space-y-6">
      <AttendanceHero
        loading={loading}
        selectedGroup={selectedGroup}
        totalGroups={groups.length}
        totalAdherents={adherents.length}
        onRefresh={actions.refresh}
      />

      {!hasSelectedGroup ? (
        <AttendanceGroupPicker
          loading={loading}
          groups={groups}
          filters={filters}
          setFilter={setFilter}
        />
      ) : (
        <>
          <AttendanceModeTabs
            activePanel={activePanel}
            onChange={setActivePanel}
          />

          {activePanel === "call" && (
            <>
              <AttendanceStats loading={loading} stats={stats} />

              <AttendanceToolbar
                loading={loading}
                filters={filters}
                setFilter={setFilter}
                selectedGroup={selectedGroup}
                totalCount={groupAdherents.length}
                filteredCount={filteredAdherents.length}
                onRefresh={actions.refresh}
                onChangeGroup={actions.changeGroup}
              />

              {filteredAdherents.length === 0 ? (
                <AttendanceEmptyState />
              ) : (
                <AttendanceAdherentsGrid
                  loading={loading}
                  adherents={filteredAdherents}
                  attendance={attendance}
                  savingIds={savingIds}
                  assiduityInfo={assiduityInfo}
                  onToggle={actions.toggleAttendance}
                  requestAssiduity={actions.loadAssiduity}
                />
              )}
            </>
          )}

          {activePanel === "table" && (
            <AttendanceTablePanel
              loading={loading}
              selectedGroup={selectedGroup}
              months={table.months}
              selectedMonth={table.selectedMonth}
              setSelectedMonth={table.setSelectedMonth}
              rows={table.rows}
              kpis={table.kpis}
              highlightIds={table.highlightIds}
              onToggleCell={table.toggleCell}
              onRefresh={actions.refresh}
              onChangeGroup={actions.changeGroup}
            />
          )}

          {activePanel === "charts" && (
            <AttendanceChartsPanel
              loading={loading}
              selectedGroup={selectedGroup}
              seasonActive={charts.seasonActive}
              chartData={charts.chartData}
              totals={charts.totals}
              onRefresh={actions.refresh}
            />
          )}

          {activePanel === "delete" && (
            <AttendanceDeletePanel
              loading={loading}
              selectedGroup={selectedGroup}
              form={deletePanel.form}
              setFormValue={deletePanel.setFormValue}
              onDelete={deletePanel.deletePeriod}
              result={deletePanel.result}
            />
          )}
        </>
      )}

      <ToastContainer position="bottom-right" theme="colored" />
    </div>
  );
}